
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Qui le fabrique?`}</em></p>
    <p>{`En mars 2021, un changement de nom a été annoncé: ce produit s'appelle désormais
Vaxzevria. Il a été développé par l’Université d’Oxford et la compagnie
britannique et suédoise AstraZeneca.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;